module.exports = __webpack_public_path__ + "media/steps/carq_spinner_1_old-ac5ec8a0.png";